export const superAgentSidebarButtonDataAutomation = {
    button: "super-agent-sidebar-button",
    buttonText: "super-agent-sidebar-button-text",
    buttonShortCut: "super-agent-sidebar-button-shortcut",
};
